import React from 'react';
import { styled } from '@linaria/react';

import NavigationListItem from 'components-v3/NavigationListItem/index.jsx';
import { useNavigation } from 'hooks/index.js';

const NavigationContainer = styled.ul`
  position: relative;
  z-index: 1;
  list-style-type: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  margin: 12px 0 0;
  max-height: 548px;

  > li {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const NavigationList = ({ setIsSidebarCollapsed, collapsed, ...props }) => {
  const { navigationElements, openedSubMenu, setOpenedSubMenu } = useNavigation();

  const expandSidebar = () => {
    setIsSidebarCollapsed(false);
  };

  return (
    <NavigationContainer {...props}>
      {navigationElements.map(({ title, dataTestId, icon, route, routeParams, exact, url, disabled, submenu }) => (
        <NavigationListItem
          key={title}
          title={title}
          icon={icon}
          route={route}
          routeParams={routeParams}
          exact={exact}
          url={url}
          disabled={disabled}
          submenu={submenu}
          dataTestId={dataTestId}
          isSubMenuOpen={openedSubMenu === title}
          collapsed={collapsed}
          setOpenedSubMenu={setOpenedSubMenu}
          onExpandSubMenuButtonClick={expandSidebar}
          data-test-id={`${title}SidebarItem`}
        />
      ))}
    </NavigationContainer>
  );
};

export default NavigationList;
